import { AsyncPipe, NgTemplateOutlet, UpperCasePipe } from '@angular/common';
import { Component, OnInit, TemplateRef, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DividendReInvestFacade, DividendReInvestSettings } from '@zero/shared/feature-dividend-re-invest/base';
import { ButtonComponent, CheckboxComponent, ModalComponent } from '@zero/shared/ui-web-design-system';

@Component({
  selector: 'shared-dividend-re-invest-self-service',
  imports: [TranslocoPipe, UpperCasePipe, AsyncPipe, NgTemplateOutlet, ModalComponent, CheckboxComponent, ButtonComponent],
  templateUrl: './dividend-re-invest-self-service.component.html',
  styleUrl: './dividend-re-invest-self-service.component.scss',
})
export class DividendReInvestSelfServiceComponent implements OnInit {
  public readonly facade = inject(DividendReInvestFacade);
  readonly #modal = inject(NgbModal);
  public isCheckboxChecked = false;
  public chosenAmountFrom: number;

  ngOnInit(): void {
    this.facade.loadCurrentSettings();
  }

  public openModal(template: TemplateRef<HTMLElement>, currentSettings: DividendReInvestSettings, amountFrom: number): void {
    if (currentSettings?.amountFrom === amountFrom) {
      return;
    }
    this.chosenAmountFrom = amountFrom;
    this.#modal.open(template, { size: 'lg', centered: true }).result.then(() => (this.chosenAmountFrom = null));
  }
}
